import { getCourse } from "./courses"

// export const getSchoolListUrl = (pincode)=> `https://0or4up9k52.execute-api.ap-southeast-1.amazonaws.com/dev/getschool?pincode=${pincode}`
export const getSchoolListUrl = (pincode)=> `https://1j1n7yyfwf.execute-api.ap-south-1.amazonaws.com/prod/getschool?pincode=${pincode}`

export const BOARDS = ["CBSE","ICSE"]
export const GRADES = [10,9,8,7,6]
export const SUBJECTS = [
    { "name": "PHYSICS", shortcode: "physics",displayName:"phy", color: "#2BBAD6" },
    { "name": "CHEMISTRY", shortcode: "chemistry",displayName:"chem", color: "#F58635" },
    { "name": "BIOLOGY", shortcode: "biology", displayName:"bio",color: "#DE3E3E" },
    { "name": "MATHS", shortcode: "maths",displayName:"math", color: "#CE97ED" },
    { "name": "CIVICS", shortcode: "civics",displayName:"civics", color: "#ff12ED" },
    { "name": "ECONOMICS", shortcode: "economics",displayName:"civics", color: "#ff12ED" },
    { "name": "HISTORY", shortcode: "history",displayName:"civics", color: "#ff12ED" },
    { "name": "GEOGRAPHY", shortcode: "geography",displayName:"geography", color: "#1212ED" }
]
export const getFilterSubjects = ()=>{
    return SUBJECTS.filter(s=>s.name !== "CIVICS" && s.name !=="GEOGRAPHY" && s.name !=="HISTORY" && s.name !=="ECONOMICS")
}
export const getSocialScienceSubjects = (board,grade)=>{
    const social_subjects = ["CIVICS","ECONOMICS","HISTORY","GEOGRAPHY"];
    let subjectToReturn = [];
    social_subjects.forEach((subject)=>{
        const course = getCourse(board,grade,subject);
        if (course){
            subjectToReturn.push(SUBJECTS.filter(sub => sub.name === subject)[0])
        }
    })
    return subjectToReturn;
}
export const getSubjectByName = subname=>{
    const filtered = SUBJECTS.filter(s=>s.name=== subname || s.shortcode === subname)[0]
    return filtered
}
export const getSubjectColor = subname=>{
    const filtered = SUBJECTS.filter(s=>s.name=== subname || s.shortcode === subname)[0]
    return filtered?filtered.color:"#a2a2a2"
}
export const SECTIONS = ["A","B","C","D","E","F","G","H"]
